
    import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
    import AbpBase from '@/lib/abpbase'
    import VWidget from '@/components/VWidget.vue';
    import Util from '@/lib/util';

    @Component({
        components: { VWidget },
    })

    export default class Widgets extends AbpBase {
        loading: boolean = false;
        checking: boolean = false;
        heartbeats: Array<any> = [];

        get widgets() {
            return [
                { title: 'Clientes', icon: 'person', symbol: '#', value: this.values[0] },
                { title: 'Pagos', icon: 'mdi-heart-pulse', symbol: 'S/', value: this.values[1] },
                { title: 'Por Cobrar', icon: 'mdi-credit-card', symbol: 'S/', value: this.values[2] },
                { title: 'Por Pagar', icon: 'touch_app', symbol: 'S/', value: this.values[3] },
            ];
        }

        get values() {
            return this.$store.state.dashboard.widgets;
        }

        get month() {
            return (this as any).$moment().format('MMMM');
        }

        //get avg() {
        //    const sum = this.heartbeats.reduce((acc, cur) => acc + cur, 0)
        //    const length = this.heartbeats.length

        //    if (!sum && !length) return 0

        //    return Math.ceil(sum / length)
        //}
        
        //heartbeat() {
        //    return Math.ceil(Math.random() * (120 - 80) + 80)
        //}
        //async takePulse(inhale = true) {
        //    this.checking = true

        //    //inhale && await exhale(1000)

        //    this.heartbeats = Array.from({ length: 20 }, this.heartbeat)

        //    this.checking = false
        //}
        async loadData() {
            this.checking = true

            await this.$store.dispatch({
                type: 'dashboard/getWidgetValues'
            });

            this.checking = false
        }

        mounted() { 
            //this.loadData();
        }
    }
